import { FormValidationErrors } from '@/interfaces/Form';
import * as Yup from 'yup';

const MIN_PASSWORD_LENGTH = 8;
const MAX_PASSWORD_LENGTH = 20;
const SPECIAL_CHARACTERS = /[!@#$%^&*)(+=._-]+/;

export const updateProfileValidationSchema = Yup.object().shape({
  username: Yup.string().required(FormValidationErrors.REQUIRED),
  email: Yup.string().email(FormValidationErrors.INVALID_EMAIL).required(FormValidationErrors.REQUIRED),
});

export const changePasswordValidationSchema = Yup.object().shape({
  currentPassword: Yup.string().required(FormValidationErrors.REQUIRED),
  newPassword: Yup.string()
    .required(FormValidationErrors.REQUIRED)
    .min(MIN_PASSWORD_LENGTH, FormValidationErrors.MIN_LENGTH)
    .max(MAX_PASSWORD_LENGTH, FormValidationErrors.MAX_LENGTH)
    .matches(SPECIAL_CHARACTERS, FormValidationErrors.SPECIAL_CHAR_REQUIRED)
    .matches(/[a-z]+/, FormValidationErrors.LOWERCASE_CHAR_REQUIRED)
    .matches(/[A-Z]+/, FormValidationErrors.UPPERCASE_CHAR_REQUIRED),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), undefined], FormValidationErrors.PASSWORDS_MATCH)
    .required(FormValidationErrors.REQUIRED),
});

